import {
  NavigationMenu,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";

export const MainNav = () => {
  return (
    <div className="flex items-center justify-between w-full">
      <NavigationMenu>
        <NavigationMenuList />
      </NavigationMenu>
    </div>
  );
};